/* CUBE STORE - un modulo alla volta, davvero

   IL PROBLEMA
   Magical Form Fields convalida TUTTI i suoi gruppi quando si preme il
   pulsante di acquisto, anche quelli nascosti. I due campi obbligatori
   del modulo "Prenotazione con Acconto" restavano vuoti mentre il
   cliente compilava "Pagamento su misura", e l'app fermava l'ordine
   senza spiegazioni: l'errore veniva scritto su un campo che in quel
   momento non era nemmeno a schermo.

   Sintomo: si premeva PRENOTA nella finestra del pagamento su misura e
   non succedeva niente. Nessun messaggio, nessun errore in console,
   carrello vuoto. Il peggior modo di rompersi.

   Nasconderli con il CSS non basta: un campo nascosto viene convalidato
   e inviato lo stesso.

   LA CURA
   Si disattivano i campi del gruppo che non si sta usando. Un campo
   disattivato non viene convalidato e non viene inviato - due problemi
   risolti dalla stessa riga, perche' cosi' nell'ordine finiscono solo
   le risposte del modulo che il cliente ha davvero compilato.

   ALL'AVVIO SONO DISATTIVATI TUTTI E DUE
   Chi aggiunge al carrello senza aprire nessuna delle due finestre non
   deve trovare l'acquisto bloccato da campi che non ha mai visto.

   ALLA CHIUSURA RESTA ACCESO L'ULTIMO USATO
   Chi compila la finestra, la chiude e poi preme il pulsante della
   pagina si aspetta che quello che ha scritto arrivi lo stesso.

   ==========================================================
   PERCHE' NON SI SPENGONO ENTRAMBI ALLA CHIUSURA
   ==========================================================

   Prima questo file, a finestra chiusa, spegneva tutti e due i gruppi -
   il contrario di quanto promette la riga qui sopra. Il risultato non
   era nemmeno quello: restava uno stato a meta', con la casella del
   metodo spenta e il suo importo acceso. Un ordine partito da un'altra
   strada avrebbe portato "Importo Bonifico (Acconto): 720" e nessuna
   modalita' di pagamento: un numero senza la frase che lo spiega.

   IL MOTIVO, MISURATO E NON INDOVINATO. Guardando l'attributo disabled
   di quel campo durante la chiusura si vedeva una partita a ping-pong:
   true, false, true, false. Noi lo spegnevamo, Magical lo riaccendeva -
   per lei quel campo e' attivo, visto che la sua casella e' spuntata -
   e l'ultima parola restava a lei.

   Si e' smesso di litigare invece di litigare piu' forte. Tenendo
   acceso il gruppo che il cliente ha usato si vuole la stessa cosa che
   vuole Magical, il ping-pong non nasce proprio, e nell'ordine arriva
   una dichiarazione COMPLETA invece di un valore orfano. L'altro
   gruppo resta spento, quindi il guasto per cui questo file esiste non
   torna.

   E se il gruppo acceso avesse un campo obbligatorio lasciato vuoto?
   Ci pensa cube-azioni.js: ascolta l'evento invalid, riapre la
   finestra giusta e mette il fuoco sul campo che manca. Quel blocco
   silenzioso e' gia' stato reso parlante.

   ==========================================================
   L'OSSERVATORE NON GUARDA GLI ATTRIBUTI, ED E' UNA CICATRICE
   ==========================================================

   Sembra una dimenticanza: se Magical riaccende un campo cambiando
   solo disabled, senza aggiungere o togliere elementi, noi non ce ne
   accorgiamo. Aggiungere attributeFilter: ['disabled'] e' la prima
   cosa che viene in mente. E' stata provata, MISURATA E TOLTA.

   Con quella riga la pagina faceva 900 modifiche al secondo: 60 al
   secondo, cioe' una per fotogramma, su ognuno dei campi del gruppo
   NON in uso. Noi lo spegniamo, Magical se ne accorge e lo riaccende,
   noi ce ne accorgiamo e lo rispegniamo. Due osservatori che si
   inseguono a 60 fotogrammi al secondo, per sempre, su una scheda
   prodotto che sembra ferma.

   Guardando solo comparse e sparizioni la rincorsa non parte: le
   occasioni in cui ricontrolliamo sono poche e distanti, e in mezzo
   nessuno insiste. Chi in futuro vorra' quella riga sappia che il
   prezzo non e' teorico: si misura aprendo la finestra, chiudendola e
   contando le mutazioni per un secondo. A pagina ferma devono essere
   zero.

   Chi apre le finestre chiama abilitaSolo(): la funzione vive su
   window perche' e' assets/cube-azioni.js a doverla usare, ed e' un
   file separato. */
(function () {
  /* l'ultimo modulo che il cliente ha davvero aperto: null finche' non
     ne apre uno, ed e' cio' che tiene tutto spento all'avvio */
  var ultimo = null;

  function gruppi() {
    return document.querySelectorAll('.ma-custom-field-group');
  }

  function abilitaSolo(tipo) {
    if (tipo) ultimo = tipo;

    gruppi().forEach(function (g) {
      var attivo = tipo && g.classList.contains('cube-gruppo--' + tipo);
      g.querySelectorAll('input, select, textarea').forEach(function (campo) {
        campo.disabled = !attivo;
      });
    });
  }

  window.cubeAbilitaSolo = abilitaSolo;

  /* A finestra chiusa resta acceso l'ultimo modulo usato, e spento
     l'altro. Va rifatto a ogni ridisegno dell'app, che ricrea i campi
     abilitati: senza, il blocco tornerebbe da solo dopo un cambio di
     taglia. Non si tocca niente se una finestra e' aperta, altrimenti
     si spegnerebbero i campi che il cliente sta compilando. */
  function riposo() {
    var modale = document.getElementById('cube-modale');
    if (modale && !modale.hidden) return;
    if (!document.querySelector('.cube-gruppo')) return;
    abilitaSolo(ultimo);
  }

  var inCoda = false;
  function programma() {
    if (inCoda) return;
    inCoda = true;
    requestAnimationFrame(function () {
      inCoda = false;
      riposo();
    });
  }

  function init() {
    riposo();
    if (!document.body) return;
    /* solo childList: vedi "L'OSSERVATORE NON GUARDA GLI ATTRIBUTI" */
    new MutationObserver(programma).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
